import { render, staticRenderFns } from "./RegistrationLayout.vue?vue&type=template&id=5f440f2a&scoped=true&"
import script from "./RegistrationLayout.vue?vue&type=script&lang=js&"
export * from "./RegistrationLayout.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationLayout.vue?vue&type=style&index=0&id=5f440f2a&prod&lang=less&"
import style1 from "./RegistrationLayout.vue?vue&type=style&index=1&id=5f440f2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f440f2a",
  null
  
)

export default component.exports